import { defineMessages } from 'react-intl';

const translations = {
  totals: {
    subtotal: {
      id: 'pages.invoiceItem.totals.subtotal',
      defaultMessage: 'Subtotal',
      description: 'Label of the subtotal in the totals form section',
    },
    vat: {
      id: 'pages.invoiceItem.totals.vat',
      defaultMessage: 'VAT',
      description: 'Label of the vat in the totals form section',
    },
    vatShifted: {
      id: 'pages.invoiceItem.totals.vatShifted',
      defaultMessage: 'shifted',
      description: 'Label of the of shifted vat in the totals form section',
    },
    total: {
      id: 'pages.invoiceItem.totals.total',
      defaultMessage: 'Total',
      description: 'Label of the total in the totals form section',
    },
    incl: {
      id: 'pages.invoiceItem.totals.incl',
      defaultMessage: 'incl.',
      description: 'suffix of an including vat total in the totals form section',
    },
    excl: {
      id: 'pages.invoiceItem.totals.excl',
      defaultMessage: 'excl.',
      description: 'suffix of an including vat total in the totals form section',
    },
  },
};

export default defineMessages(translations);
